import { useCallback } from "react";
import { useRequest } from "../useRequest.hook";
import { useAppData } from "../../contexts/appData.context";

interface OrderHistoryParams {
    fromDate?: string;
    toDate?: string;
    sortOrder?: "ASC" | "DESC";
    pageSize?: string;
    pageNumber?: string;
    version?: string;
}

export const useOrderHistoryApi = () => {
    const request = useRequest();
    const { siteVariant, customerNumber } = useAppData();

    const getOrderHistory = useCallback(
        (parameters?: OrderHistoryParams) => {
            // For hatting-agro-b2b, use customer number in the path
            const path =
                siteVariant?.alias === "hatting-agro-b2b" && customerNumber
                    ? `/api/orders/history/${customerNumber}`
                    : "/api/orders/history";

            const qs = parameters
                ? new URLSearchParams(
                      Object.entries(parameters)
                          // Exclude null or empty values
                          .filter(([, value]) => value !== null && value !== "")
                          // Ensure all values are strings
                          .map(([key, value]) => [key, String(value)])
                  )
                : null;
            const url = qs && qs.toString() ? `${path}?${qs}` : path;
            return request.get(url);
        },
        [request, siteVariant, customerNumber]
    );
    return { getOrderHistory };
};
